export default __webpack_public_path__ + "media/fonts/montserrat-black.ttf";